// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios"; // ✅ IMPORTANT
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";
// import { FaStar, FaShoppingCart, FaEye } from "react-icons/fa";
// import { useTranslation } from "react-i18next";

// import "swiper/css";
// import "swiper/css/navigation";

// import bannerImg from "../../images/side_img1.jpg";

// const API_BASE = "https://api.mahal.qa"; // ✅ SAME AS SECOND FILE

// /* PRICE FIX */
// const parsePrice = (val) => {
//   if (!val) return 0;
//   return Number(String(val).replace(/[^\d.]/g, "")) || 0;
// };

// const BestSellProducts = () => {
//   const [products, setProducts] = useState([]);
//   const [ratings, setRatings] = useState({});
//   const { t, i18n } = useTranslation();
// const isArabic = i18n.language === "ar";

// const getProductName = (p) => {
//   return isArabic
//     ? p.name_ar || p.product_name_arabic || p.name
//     : p.name_en || p.product_name_english || p.name;
// };

// const localizeNumber = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
//     Number(value || 0)
//   );
// };

// const localizeDecimal = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US", {
//     minimumFractionDigits: 1,
//     maximumFractionDigits: 1,
//   }).format(Number(value || 0));
// };

// const localizeCurrency = (value) => {
//   return isArabic
//     ? `${localizeNumber(value)} ${t("qar")}`
//     : `${t("qar")} ${localizeNumber(value)}`;
// };

// const localizePercent = (value) => {
//   return isArabic
//     ? `${localizeNumber(value)}٪`
//     : `${localizeNumber(value)}%`;
// };
//   /* ================= FETCH ================= */
//   useEffect(() => {
//     fetch(`${API_BASE}/api/deals-of-the-day`)
//       .then((res) => res.json())
//       .then((data) => {
//         let items = data.data || data.products || [];

//         if (!items.length) {
//           return fetch(`${API_BASE}/api/gridlist`)
//             .then((res) => res.json())
//             .then((data2) => {
//                const list = data2.products || [];
//             setProducts(list);
//             fetchRatings(list);
//             });
//         }

//         setProducts(items);
//         fetchRatings(items);
//       })
//       .catch((err) => {
//         console.error("FETCH ERROR:", err);
//       });
//   }, []);


//     const fetchRatings = async (products) => {
//       try {
//         const ratingData = {};

//         await Promise.all(
//           products.map(async (p) => {
//             try {
//               const res = await fetch(
//                 `${API_BASE}/api/reviews/products/${p.id}`
//               );
//               const data = await res.json();

//               if (data.length > 0) {
//                 const total = data.reduce((sum, r) => sum + r.rating, 0);
//                 ratingData[p.id] = total / data.length;
//               } else {
//                 ratingData[p.id] = 0;
//               }
//             } catch {
//               ratingData[p.id] = 0;
//             }
//           })
//         );

//         setRatings(ratingData);
//       } catch (err) {
//         console.error("Rating fetch error:", err);
//       }
//     };

//   /* ================= ADD TO CART (LIKE SECOND FILE) ================= */
//  const addToCart = (item) => {

//   const token = localStorage.getItem("token");

//   if (!token) {
//     alert(t("please_login"));
//     return;
//   }

//   axios.post(
//     `${API_BASE}/api/cart/add`,
//     {
//       product_id: item.id,
//       quantity: 1,
//       price: item.price_numeric || parsePrice(item.price),
//     },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   )

//   .then((res) => {

//     // ✅ Already exists in cart
//     if (res.data.status === "exists") {

// alert(t("product_already_cart"));

//     }

//     // ✅ New product added
//     else {

//       alert(t("added_to_cart"));

//     }

//   })

//   .catch((err) => {

//     console.error("CART ERROR", err);

// alert(err.response?.data?.error || t("backend_error"));

//   });

// };

//   return (
//     <section className="best_sell popular_products mt_100 xs_mt_80">
//       <div className="container">

//         {/* HEADING */}
//         <div className="row">
//           <div className="col-xl-5 m-auto">
//             <div className="section_heading text-center heading_left mb_25 m-auto">
//               <h4 className="premium_badge text-white">
//                 🔥 {t("best_selling_offers")}
//               </h4>
//               <h2 className="premium_title">{t("top_deals_for_you")}</h2>
//             </div>
//           </div>
//         </div>

//         <div className="row mt-5">

//           {/* LEFT BANNER */}
//           <div className="col-xl-3 col-md-6 col-lg-4">
//             <div className="special_product_banner">
//               <img src={bannerImg} alt="special" className="img-fluid w-100" />
//               <div className="text">
//                 <h5>{t("hot_deals")}</h5>
//                 <h3>{t("save_big_today_offers")}</h3>
//                 <Link to="/ShopDetails" className="common_btn">
//                   {t("shop_now")} <i className="fas fa-long-arrow-right"></i>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* PRODUCT SLIDER */}
//           <div className="col-xl-9 col-md-6 col-lg-8">
//             <Swiper
//                 key={isArabic ? "ar" : "en"}
//                 dir={isArabic ? "rtl" : "ltr"}
//               modules={[Navigation, Autoplay]}
//               slidesPerView={4}
//               spaceBetween={10}
//               navigation
//               autoplay={{ delay: 3500 }}
//               loop
//               breakpoints={{
//                 0: { slidesPerView: 1 },
//                 576: { slidesPerView: 2 },
//                 768: { slidesPerView: 3 },
//                 1200: { slidesPerView: 4 },
//               }}
//               className="best_sell_slider"
//             >
//               {products.map((p) => {

//                 const price =
//                   p.price_numeric ??
//                   p.selling_price ??
//                   parsePrice(p.price);

//                 const old =
//                   p.old_price_numeric ??
//                   p.mrp ??
//                   parsePrice(p.old_price);

//                 const discount =
//                   old > price
//                     ? Math.round(((old - price) / old) * 100)
//                     : 0;

//                 return (
//                   <SwiperSlide key={p.id}>
//                     <div className="mm-product-card">

//                       {/* DISCOUNT */}
//                       {discount > 0 && (
//                         <span className="mm-discount-badge">
//                           {localizePercent(discount)} {t("off")}
//                         </span>
//                       )}

//                       {/* IMAGE */}
//                       <div className="mm-product-img">
//                        <img
//                         src={
//                           p.img1 && p.img1.trim() !== ""
//                             ? p.img1.startsWith("http")
//                               ? p.img1
//                               : `${API_BASE}/${p.img1}`
//                             : null
//                         }
//                         alt={getProductName(p)}
//                         onError={(e) => {
//                           console.log("Image failed:", p.img1);
//                           e.target.style.display = "none";
//                         }}
//                       />
//                       </div>

//                       {/* CONTENT */}
//                       <div className="mm-product-content">

//                         {/* RATING */}
//                         {/* <div className="mm-rating">
//                           {Array.from({ length: 5 }).map((_, i) => (
//                             <FaStar
//                               key={i}
//                               className={
//                                 i < Math.floor(p.rating || 4) ? "active" : ""
//                               }
//                             />
//                           ))}
//                         </div> */}

//                         {/* RATING */}
//                         <div
//                           className="mm-rating"
//                         >
//                           {Array.from({ length: 5 }).map((_, i) => (
//                             <FaStar
//                               key={i}
//                               color={
//                                 i < Math.round(ratings[p.id] || 0)
//                                   ? "#f59e0b"
//                                   : "#d1d5db"
//                               }
//                               size={13}
//                             />
//                           ))}

//                           <span
                            
//                           >
//                             ({localizeDecimal(ratings[p.id] || 0)})
//                           </span>
//                         </div>

//                         {/* TITLE */}
//                         <Link
//                           to={`/shopdetails/${p.id}`}
//                           className="mm-product-title"
//                         >
//                          {getProductName(p)}
//                         </Link>

//                         {/* PRICE */}
//                           <div className="mm-price">
//                             <span className="mm-new">
//                               {localizeCurrency(price)}
//                             </span>

//                             {old > price && (
//                               <span className="mm-old">
//                                 {localizeCurrency(old)}
//                               </span>
//                             )}
//                           </div>

//                         {/* ACTIONS */}
//                         <div className="mm-actions">

//                           {/* ADD TO CART */}
//                           <button
//                             onClick={() => addToCart(p)}
                          
//                           >
//                             <FaShoppingCart />
//                           </button>

//                           {/* VIEW */}
//                           <Link to={`/shopdetails/${p.id}`}>
//                             <FaEye />
//                           </Link>

//                         </div>

//                       </div>
//                     </div>
//                   </SwiperSlide>
//                 );
//               })}
//             </Swiper>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default BestSellProducts;






import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios"; // ✅ IMPORTANT
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { FaStar, FaShoppingCart, FaEye } from "react-icons/fa";
import { formatPrice, getCurrencySymbol } from "../../utils/currency";

import "swiper/css";
import "swiper/css/navigation";

import bannerImg from "../../images/side_img1.jpg";

const API_BASE = "https://api.mahal.qa"; // ✅ SAME AS SECOND FILE

/* PRICE FIX */
const parsePrice = (val) => {
  if (!val) return 0;
  return Number(String(val).replace(/[^\d.]/g, "")) || 0;
};

const BestSellProducts = () => {
  const [products, setProducts] = useState([]);
  // const [ratings, setRatings] = useState({});

  useEffect(() => {

    const loadProducts = async () => {

      try {

        const res = await fetch(
          `${API_BASE}/api/top-deals-slider`
        );

        // const data = await res.json();

        if (!res.ok) {
          throw new Error("API Failed");
        }

        const data = await res.json();

        const items = Array.isArray(data.products)
          ? data.products
          : [];

        // ONLY OFFER PRODUCTS
        // const filtered = items.filter(
        //   (p) => p && p.has_offer
        // );

        // setProducts(filtered);

        setProducts(items || []);

        // if (filtered.length > 0) {
        //   fetchRatings(filtered);
        // }

      } catch (err) {

        console.error(
          "PRODUCT FETCH ERROR:",
          err
        );

      }
    };

    loadProducts();

  }, []);

  // const fetchRatings = async (products) => {
  //   try {
  //     const ratingData = {};

  //     await Promise.all(
  //       products.map(async (p) => {
  //         try {

  //           // const res = await fetch(
  //           //   '${API_BASE}/api/reviews/products/${p.id}'
  //           // );

  //           const res = await fetch(
  //             `${API_BASE}/api/reviews/product/${p.id}`
  //           );
  //           const data = await res.json();

  //           if (data.length > 0) {
  //             const total = data.reduce((sum, r) => sum + r.rating, 0);
  //             ratingData[p.id] = total / data.length;
  //           } else {
  //             ratingData[p.id] = 0;
  //           }
  //         } catch {
  //           ratingData[p.id] = 0;
  //         }
  //       })
  //     );

  //     setRatings(ratingData);
  //   } catch (err) {
  //     console.error("Rating fetch error:", err);
  //   }
  // };

  /* ================= ADD TO CART (LIKE SECOND FILE) ================= */
  const addToCart = (item) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login");
      return;
    }

    axios.post(
      `${API_BASE}/api/cart/add`,
      {
        product_id: item.id,
        quantity: 1,
        price: item.price_numeric || parsePrice(item.price),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(() => {
      alert("Added to cart 🛒");
    })
    .catch((err) => {
      console.error("CART ERROR", err);
      alert("Backend error");
    });
  };

  return (
    <>
    <style>
    {`
      .mm-product-card {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .mm-product-img {
        width:100%;
        height:170px;

        display:flex;
        align-items:center;
        justify-content:center;

        overflow:hidden;

        margin-top:10px;
      }

      .mm-product-img img {
        width:100%;
        height:100%;

        object-fit:contain;

        transition:0.3s ease;
      }

      .mm-product-card:hover .mm-product-img img{
        transform:scale(1.05);
      }

      .mm-product-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .mm-product-title {
        min-height:44px;

        font-size:16px;
        line-height:22px;
        font-weight:600;

        text-align:center;
        display: block;
      }

      .mm-product-card{
        position:relative;
      }

      .mm-product-qty{
        position:absolute;
        top:10px;
        right:10px;

        background:#f3f4f6;
        color:#666;

        font-size:11px;
        font-weight:700;

        padding:4px 8px;
        border-radius:6px;

        z-index:5;
      }

      @media(max-width:992px){

        .best_sell_slider{
          padding-bottom:10px;
        }

        .mm-product-card{
          min-height:340px;
        }

        .mm-product-img{
          height:140px;
        }

      }

      @media(max-width:768px){

        .best_sell .row.mt-5{
          gap:20px;
        }

        .special_product_banner{
          margin-bottom:20px;
        }

        .best_sell_slider .swiper-slide{
          width:auto !important;
        }

        .mm-product-card{

          width:190px;
          min-width:190px;

          min-height:320px;

          padding:10px;
          margin:auto;
        }

        .mm-product-img{
          height:120px;
          margin-top:5px;
        }

        .mm-product-title{
          font-size:14px;
          line-height:20px;
          min-height:40px;
        }

        .mm-product-qty{
          font-size:10px;
          padding:3px 6px;
        }

        .mm-rating{
          display:flex;
          align-items:center;
          justify-content:center;
          gap:3px;

          font-size:11px;
        }

        .mm-price{
          display:flex;
          align-items:center;
          justify-content:center;
          gap:6px;

          margin-top:5px;
        }

        .mm-new{
          font-size:16px;
          font-weight:700;
        }

        .mm-old{
          font-size:11px;
        }

      }

      @media(max-width:576px){

        .mm-product-card{

          min-height:300px;

          border-radius:12px;
        }

        .mm-product-img{
          height:100px;
        }

        .mm-product-title{
          font-size:13px;
          line-height:18px;
        }

        .mm-new{
          font-size:15px;
        }

        .mm-old{
          font-size:11px;
        }

        .mm-rating{
          font-size:10px;
        }

        .mm-actions button,
        .mm-actions a{

          width:32px;
          height:32px;

          display:flex;
          align-items:center;
          justify-content:center;
        }

      }
    `}
    </style>

      <section className="best_sell popular_products mt_100 xs_mt_80">
        <div className="container">

          {/* HEADING */}
          <div className="row">
            <div className="col-xl-5 m-auto">
              <div className="section_heading text-center heading_left mb_25 m-auto">
                <h4 className="premium_badge text-white">
                  🔥 Best Selling Offers
                </h4>
                <h2 className="premium_title">Top Deals For You</h2>
              </div>
            </div>
          </div>

          <div className="row mt-5">

            {/* LEFT BANNER */}
            <div className="col-xl-3 col-md-6 col-lg-4">
              <div className="special_product_banner">
                <img src={bannerImg} alt="special" className="img-fluid w-100" />
                <div className="text">
                  <h5>Hot Deals</h5>
                  <h3>Save Big on Today’s Offers</h3>
                  {/* <Link to="/ShopDetails" className="common_btn">
                    shop now <i className="fas fa-long-arrow-right"></i>
                  </Link> */}
                  <Link
                    to="/offer-products?type=today"
                    className="common_btn"
                  >
                    shop now
                    <i className="fas fa-long-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* PRODUCT SLIDER */}
            <div className="col-xl-9 col-md-6 col-lg-8">
            {/* <div className="col-xl-9 col-md-12 col-lg-8"> */}
              {/* <Swiper */}
              {products.length > 0 && (
              <Swiper 
                key={products.length}
                modules={[Navigation, Autoplay]}
                // slidesPerView={4}
                slidesPerView={
                  products.length >= 4
                    ? 4
                    : products.length || 1
                }
                slidesPerGroup={1}
                spaceBetween={12}
                speed={700}
                observer={true}
                observeParents={true}
                watchOverflow={true}
                centeredSlides={false}
                // loopFillGroupWithBlank={false}
                navigation={products.length > 4}
                loop={products.length > 4}
                rewind={products.length <= 4}
                // loop={false}
                // rewind={true}
                // watchSlidesProgress={true}
                autoplay={
                  products.length > 1
                    ? {
                        delay: 2200,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }
                    : false
                }
                // breakpoints={{
                //   0: {
                //     slidesPerView: 1,
                //   },
                //   576: {
                //     slidesPerView: 2,
                //   },
                //   768: {
                //     slidesPerView: 2,
                //   },
                //   992: {
                //     slidesPerView: 3,
                //   },
                //   1200: {
                //     slidesPerView: 4,
                //   },
                // }}
                breakpoints={{

                  0: {
                    slidesPerView: "auto",
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 14,
                  },

                  992: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                  },

                  1200: {
                    slidesPerView:
                      products.length >= 4
                        ? 4
                        : products.length || 1,

                    spaceBetween: 18,
                  },

                }}

                className="best_sell_slider"
              >
                {/* {products.map((p) => { */}
                {Array.isArray(products) && products.map((p, index) => {

                  const price =
                    p.price_numeric ??
                    p.selling_price ??
                    parsePrice(p.price);

                  const old =
                    p.old_price_numeric ??
                    p.mrp ??
                    parsePrice(p.old_price);

                  // const discount =
                  //   old > price
                  //     ? Math.round(((old - price) / old) * 100)
                  //     : 0;

                  return (
                    // <SwiperSlide key={p.id}>
                    <SwiperSlide key={`${p.id}-${index}`}>
                      <div className="mm-product-card">

                        {/* DISCOUNT */}
                        {/* {discount > 0 && (
                          <span className="mm-discount-badge">
                            {discount}% OFF
                          </span>
                        )} */}

                        {p.offer_label && (
                          <span className="mm-discount-badge">
                            {p.offer_label}
                          </span>
                        )}

                        <span className="mm-product-qty">
                          {p.unit_of_measure
                            ? p.unit_of_measure.toUpperCase()
                            : "UNIT"}
                        </span>

                        {/* IMAGE */}
                        <div className="mm-product-img">
                        <img
                          loading="lazy"
                          decoding="async"
                          src={
                            p.img1 && p.img1.trim() !== ""
                              ? p.img1.startsWith("http")
                                ? p.img1
                                : `${API_BASE}/${p.img1}`
                              : null
                          }
                          alt={p.name}
                          onError={(e) => {
                            console.log("Image failed:", p.img1);
                            e.target.style.display = "none";
                          }}
                        />
                        </div>

                        {/* CONTENT */}
                        <div className="mm-product-content">

                          {/* RATING */}
                          {/* <div className="mm-rating">
                            {Array.from({ length: 5 }).map((_, i) => (
                              <FaStar
                                key={i}
                                className={
                                  i < Math.floor(p.rating || 4) ? "active" : ""
                                }
                              />
                            ))}
                          </div> */}

                          {/* RATING */}
                          <div className="mm-rating">

                            {Array.from({ length: 5 }).map((_, i) => (

                              <FaStar
                                key={i}
                                color={
                                  i < Math.round(p.rating || 0)
                                    ? "#f59e0b"
                                    : "#d1d5db"
                                }
                                size={13}
                              />

                            ))}

                            <span>
                              ({Number(p.rating || 0).toFixed(1)})
                            </span>

                            {/* <span>
                              ({Number(p.rating || 0).toFixed(1)})
                              •
                              {p.reviews || 0} Reviews
                            </span> */}

                          </div>

                          {/* TITLE */}

                          {/* <Link
                            to={`/shopdetails/${p.id}`}
                            className="mm-product-title"
                          >
                            {p.name}
                          </Link> */}

                          <Link
                            // to={`/shopdetails/${p.id}?type=today`}
                            to={`/shopdetails/${p.id}?type=today`}
                            state={{
                              offerData: {
                                has_offer: p.has_offer,
                                offer_type: p.offer_type,
                                offer_label: p.offer_label,
                                discounted_price: p.discounted_price,
                                original_price: p.original_price,
                                discount_percentage: p.discount_percentage,
                                flat_amount: p.flat_amount,
                                buy_quantity: p.buy_quantity,
                                get_quantity: p.get_quantity,
                              }
                            }}
                            className="mm-product-title"
                          >
                            {p.name}
                          </Link>
                          
                          <div className="mm-price">

                            <span className="mm-new">
                              {
                                formatPrice(
                                  p.discounted_price || price,
                                  p.currency
                                )
                              }
                            </span>

                            {p.has_offer &&
                              Number(p.original_price || price) >
                              Number(p.discounted_price || price) && (
                                <span className="mm-old">
                                  {
                                    formatPrice(
                                      p.original_price || price,
                                      p.currency
                                    )
                                  }
                                </span>
                              )}

                          </div>

                          {/* <div className="mm-price">

                            <span className="mm-new">
                              {formatPrice(
                                Number(
                                  p.discounted_price ||
                                  p.price_numeric ||
                                  p.selling_price ||
                                  0
                                ),
                                p.currency || "QAR"
                              )}
                            </span>

                            {Number(
                              p.original_price ||
                              p.old_price_numeric ||
                              0
                            ) >

                            Number(
                              p.discounted_price ||
                              p.price_numeric ||
                              0
                            ) && (

                              <span className="mm-old">

                                {formatPrice(
                                  Number(
                                    p.original_price ||
                                    p.old_price_numeric ||
                                    0
                                  ),
                                  p.currency || "QAR"
                                )}

                              </span>

                            )}

                          </div> */}

                          {/* ACTIONS */}
                          <div className="mm-actions">

                            {/* ADD TO CART */}
                            <button
                              onClick={() => addToCart(p)}
                            
                            >
                              <FaShoppingCart />
                            </button>

                            {/* VIEW */}

                            {/* <Link to={`/shopdetails/${p.id}`}>
                              <FaEye />
                            </Link> */}

                            <Link
                              to={`/shopdetails/${p.id}?type=today`}
                              state={{
                                offerData: {
                                  has_offer: p.has_offer,
                                  offer_type: p.offer_type,
                                  offer_label: p.offer_label,
                                  discounted_price: p.discounted_price,
                                  original_price: p.original_price,
                                  discount_percentage: p.discount_percentage,
                                  flat_amount: p.flat_amount,
                                  buy_quantity: p.buy_quantity,
                                  get_quantity: p.get_quantity,
                                }
                              }}
                            >
                              <FaEye />
                            </Link>

                          </div>

                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              )}
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BestSellProducts;